/* global window */
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';
import { getClubMembership } from 'redux/clubMemberships/actions';
import { listProducts } from 'redux/products/actions';

import Address from './components/Address';
import Item from './components/Item';
import { getFirstProducts } from './helpers';

const Widget = () => {
  const dispatch = useDispatch();

  const pathArray = window.location.pathname.split('/');
  const membershipId = pathArray[pathArray.length - 1];

  useEffect(() => {
    dispatch(getClubMembership(membershipId));
  }, [dispatch, membershipId]);

  const clubMembership = useSelector(
    (state) => state.clubMembership.data?.[membershipId]
  );
  const settings = useSelector((state) => state.setting);
  const products = useSelector((state) => state.product.data);

  let productIds = ``;

  if (clubMembership) {
    const { club } = clubMembership;
    clubMembership.manualItems.forEach((item) => {
      const clubItem = club.controlledSubscription.items.find(
        (i) => i.sku === item.sku
      );
      if (clubItem) {
        if (productIds.length === 0) {
          productIds += clubItem.productId;
        } else {
          productIds += `,${clubItem.productId}`;
        }
      }
    });
  }

  useEffect(() => {
    if (productIds.length > 0) {
      dispatch(listProducts(null, `&ids=${productIds}`));
    }
  }, [dispatch, productIds]);

  if (!clubMembership || !settings.data) {
    return null;
  }

  const { club } = clubMembership;

  const { firstProduct, firstDate } = getFirstProducts(
    clubMembership.manualItems,
    club,
    products
  );

  return (
    <>
      <p className="receipt-order-message">
        Please review your account details and finalize your first shipment
        below. Following your initial delivery, each wine selection will be
        shipped upon release of the next vintage, or approximately once per
        year. Your first membership release shipment will be for {firstProduct}{' '}
        in {firstDate}. We’ll be sure to send a reminder in advance of every
        release and you’ll have the opportunity to update your preferences
        online.
      </p>
      <Address clubMembership={clubMembership} />
      <p className="receipt-payment-info">
        <span className="receipt-payment-info-title">Payment</span>
        <br />
        <span className="receipt-payment-info-cc">
          <CreditCardDisplay creditCard={clubMembership.customerCreditCard} />
        </span>
      </p>
      <div className="receipt-products">
        <p className="receipt-products-title">Your Selections</p>
        <ul className="receipt-products-list">
          {clubMembership.manualItems.map((item) => {
            const newItem = item;
            const clubItem = club.controlledSubscription.items.find(
              (i) => i.sku === item.sku
            );
            newItem.image = clubItem.image;
            newItem.productTitle = clubItem.productTitle;
            newItem.price = clubItem.price;
            newItem.productId = clubItem.productId;
            return <Item item={newItem} key={item.id} />;
          })}
        </ul>
      </div>
    </>
  );
};

export default Widget;
